import dayjs from "dayjs";
import { EditableDataGrid } from "../../../../../builderPackage/components/editableDataGrid/editableDataGrid";
export var CourierDetailsDataGrid = function (props) {
    var _value$ParamsBeforeRe;
    var value = props.value, onChange = props.onChange;
    var columns = [{
            type: "singleSelect",
            field: "SerialNo",
            headerName: "Sr.No",
            editable: false,
            minWidth: 100,
            renderCell: function (params) { return params.api.getAllRowIds().indexOf(params.id) + 1; }
        }, {
            type: "string",
            field: "CourierName",
            headerName: "Courier Name",
            placeholder: 'Courier Name',
            editable: true,
            minWidth: 100,
            flex: 1
        }, {
            type: 'singleSelect',
            field: 'BranchId',
            valueOptions: value === null || value === void 0 ? void 0 : value.dealerIdList,
            headerName: "Courier Name",
            placeholder: 'Select Action'
        }, {
            type: "date",
            field: "BookingDate",
            headerName: "Booking Date",
            editable: true,
            valueGetter: function (value) {
                return value ? dayjs(value) : undefined;
            },
            placeholder: 'Select date',
            valueFormatter: function (value, row) {
                return value ? dayjs(value).format("DD/MM/YYYY") : '';
            },
            flex: 1
        }, {
            type: "string",
            field: "DocketNumber",
            headerName: "Docket Number",
            editable: true,
            minWidth: 100,
            flex: 1
        }, {
            type: "string",
            field: "NoOfSample",
            headerName: "No Of Sample",
            editable: true,
            minWidth: 100,
            flex: 1
        }];
    return /*#__PURE__*/ React.createElement(EditableDataGrid, {
        columns: columns,
        rows: value === null || value === void 0 ? void 0 : value.CourierData,
        dataGridHeader: "Courier details"
        // validationModel={{
        //     CheckedParams: (value) => {
        //         const leadingSpacesRegex = /^\S.*$/;
        //         if (!leadingSpacesRegex.test(value) && value?.length > 0) {
        //             return "Leading spaces are not allowed.";
        //         }
        //         if (!value || value?.length < 10 || value?.length > 250) {
        //             return "Parameters length must be between 10 and 250 characters.";
        //         }
        //         return undefined;
        //     },
        //     Observations: (value) => {
        //         const leadingSpacesRegex = /^\S.*$/;
        //         if (!leadingSpacesRegex.test(value) && value?.length > 0) {
        //             return "Leading spaces are not allowed.";
        //         }
        //         if (!value || value?.length < 10 || value?.length > 250) {
        //             return "Observations length must be between 10 and 250 characters.";
        //         }
        //         return undefined;
        //     }
        // }}
        ,
        onChange: onChange,
        isCollapsible: true,
        dataGridProps: {
            hideFooter: true,
            disableColumnMenu: true,
            checkboxSelection: true
        },
        visibleActions: {
            advanceSearch: false,
            manageColumns: false,
            export: false,
            upload: false,
            add: ((value === null || value === void 0 || (_value$ParamsBeforeRe = value.ParamsBeforeRepairData) === null || _value$ParamsBeforeRe === void 0 ? void 0 : _value$ParamsBeforeRe.length) || 0) < 5
        }
    });
};
